<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <ik-data-table
    :entity-name=" $t('allergicSource')"
    :model="model"
    icon="mdi-chart-bubble"
  >
    <template #item.icon="{item}">
      <v-icon>{{ item.icon }}</v-icon>
    </template>
  </ik-data-table>
</template>

<script>

  import { IkDataTable } from 'metaflow-js'
  import Allergen from '../../../../model/dish/Allergen'

  export default {
    components: {
      IkDataTable,
    },
    data: function () {
      return ({
        model: Allergen,
      })
    },
  }
</script>
